export const products = [
  {
    id: 1,
    name: "ANIPRO",
    category: "Nutrition",
    tagline: "Protein Supplement",
    description: "EPA-DHA, Iron & Zinc Sulphate Protein Powder",
    flavors: "Kesar, Chocolate, Vanilla (Sugar Free)",
    icon: "🧪",
    color: "from-blue-500 to-cyan-400",
    badge: "Best Seller",
  },
  {
    id: 2,
    name: "ANITOP-DSR",
    category: "Gastro",
    tagline: "Acid Reflux Relief",
    description: "Pantoprazole & Domperidone Capsules",
    flavors: null,
    icon: "💊",
    color: "from-violet-500 to-purple-400",
    badge: null,
  },
  {
    id: 3,
    name: "ANROMIN",
    category: "Neurology",
    tagline: "Neuropathy Support",
    description: "Methylcobalamin, Alpha Lipoic Acid 100mg, Vitamin B1, B6, B9, Folic Acid Tablets",
    flavors: null,
    icon: "🧠",
    color: "from-emerald-500 to-teal-400",
    badge: null,
  },
  {
    id: 4,
    name: "ANROVIT-GOLD",
    category: "Vitamins",
    tagline: "Premium Antioxidant",
    description: "Antioxidant, Multivitamin, Multiminerals with Green Tea Extract, Ginseng & Lycopene Tablets",
    flavors: null,
    icon: "⭐",
    color: "from-amber-500 to-yellow-400",
    badge: "Premium",
  },
  {
    id: 5,
    name: "ANROVIT",
    category: "Vitamins",
    tagline: "Daily Wellness Syrup",
    description: "Multi-Vitamin, Multi-Minerals & Antioxidants Syrup",
    flavors: null,
    icon: "🍯",
    color: "from-orange-500 to-amber-400",
    badge: null,
  },
  {
    id: 6,
    name: "ANRO-SP",
    category: "Pain Relief",
    tagline: "Anti-Inflammatory",
    description: "Aceclofenac, Paracetamol & Serratiopeptidase Tablets",
    flavors: null,
    icon: "🩹",
    color: "from-rose-500 to-pink-400",
    badge: null,
  },
  {
    id: 7,
    name: "ANROMIN-LC",
    category: "Nutrition",
    tagline: "Cardiac & Energy Support",
    description: "L-Carnitine-L-Tartrate, L-Arginine, Cyanocobalamin, Vitamin-E & Magnesium Tablets",
    flavors: null,
    icon: "❤️",
    color: "from-red-500 to-rose-400",
    badge: null,
  },
  {
    id: 8,
    name: "CLAVINIR-CV 625",
    category: "Antibiotics",
    tagline: "Broad Spectrum Antibiotic",
    description: "Amoxycillin, Potassium Clavulanate & Lactic Acid Bacillus – MTS Tablets",
    flavors: null,
    icon: "🦠",
    color: "from-indigo-500 to-blue-400",
    badge: null,
  },
  {
    id: 9,
    name: "ANROGEL",
    category: "Topical",
    tagline: "Pain Relief Gel",
    description: "Diclofenac, Diethylamine, Linseed Oil, Methyl Salicylate & Menthol with Benzyl Alcohol Gel",
    flavors: null,
    icon: "🧴",
    color: "from-teal-500 to-green-400",
    badge: null,
  },
  {
    id: 10,
    name: "KALNIR",
    category: "Bone Health",
    tagline: "Calcium Supplement",
    description: "Calcium Citrate Maleate, Cholecalciferol & Folic Acid Tablets",
    flavors: null,
    icon: "🦴",
    color: "from-sky-500 to-blue-400",
    badge: null,
  },
  {
    id: 11,
    name: "KALNIR-ORTHO",
    category: "Bone Health",
    tagline: "Herbal Joint Support",
    description: "Cissus Quadrangularis Extract, Boswellia Serrata Extract, Nirgundi and Ashwagandha",
    flavors: null,
    icon: "🌿",
    color: "from-lime-500 to-green-400",
    badge: "Herbal",
  },
  {
    id: 12,
    name: "KALNIR-PLUS",
    category: "Bone Health",
    tagline: "Advanced Bone Formula",
    description: "Calcium Citrate, Calcitriol, Magnesium, Zinc, Vitamin-D3 IU & Cyanocobalamin Tablets",
    flavors: null,
    icon: "💪",
    color: "from-blue-600 to-indigo-400",
    badge: null,
  },
  {
    id: 13,
    name: "KALNIR-D3 60K",
    category: "Vitamins",
    tagline: "Vitamin D3 Boost",
    description: "Cholecalciferol 60000 IU Softgel Capsules",
    flavors: null,
    icon: "☀️",
    color: "from-yellow-500 to-orange-400",
    badge: null,
  },
  {
    id: 14,
    name: "CALNIR SUSPENSION",
    category: "Bone Health",
    tagline: "Liquid Calcium Formula",
    description: "Calcium Carbonate, Magnesium Sulphate, Zinc Sulphate & Vitamin D3 Suspension",
    flavors: null,
    icon: "🧃",
    color: "from-cyan-500 to-teal-400",
    badge: null,
  },
  {
    id: 15,
    name: "ANROZYME",
    category: "Digestive",
    tagline: "Digestive Enzyme Syrup",
    description: "Fungal Diastase & Pepsin Syrup fortified with B-complex factors",
    flavors: null,
    icon: "🌀",
    color: "from-purple-500 to-violet-400",
    badge: null,
  },
  {
    id: 16,
    name: "ANROVIT SYRUP",
    category: "Vitamins",
    tagline: "Children's Multivitamin",
    description: "Multivitamin, Multiminerals & Antioxidants Syrup fortified with B-complex factors",
    flavors: null,
    icon: "🍬",
    color: "from-pink-500 to-rose-400",
    badge: null,
  },
  {
    id: 17,
    name: "ANRODEX-LS",
    category: "Respiratory",
    tagline: "Cough & Cold Relief",
    description: "Ambroxol Hydrochloride, Guaiphenesin & Levosalbutamol Sulphate Syrup",
    flavors: null,
    icon: "🫁",
    color: "from-sky-500 to-cyan-400",
    badge: null,
  },
  {
    id: 18,
    name: "LIVNIR-DS",
    category: "Liver",
    tagline: "Liver Care Syrup",
    description: "Silymarin, B-complex & Anise Oil Combinational Syrup",
    flavors: null,
    icon: "🫀",
    color: "from-green-600 to-emerald-400",
    badge: null,
  },
];

export const categories = [
  "All",
  "Nutrition",
  "Vitamins",
  "Bone Health",
  "Pain Relief",
  "Gastro",
  "Antibiotics",
  "Neurology",
  "Digestive",
  "Respiratory",
  "Liver",
  "Topical",
];

export const slides = [
  { id: 1, src: "/images/slide1.png", alt: "Anir Healthcare Product 1" },
  { id: 2, src: "/images/slide2.png", alt: "Anir Healthcare Product 2" },
  { id: 3, src: "/images/slide3.png", alt: "Anir Healthcare Product 3" },
  { id: 4, src: "/images/slide4.png", alt: "Anir Healthcare Product 4" },
  { id: 5, src: "/images/slide5.png", alt: "Anir Healthcare Product 5" },
  { id: 6, src: "/images/slide6.png", alt: "Anir Healthcare Product 6" },
  { id: 7, src: "/images/slide7.png", alt: "Anir Healthcare Product 7" },
  { id: 8, src: "/images/slide8.png", alt: "Anir Healthcare Product 8" },
  { id: 9, src: "/images/slide9.png", alt: "Anir Healthcare Product 9" },
  { id: 10, src: "/images/slide10.png", alt: "Anir Healthcare Product 10" },
];

export const stats = [
  { value: "18+", label: "Product Range" },
  { value: "10+", label: "Categories" },
  { value: "100%", label: "Quality Assured" },
  { value: "Pan India", label: "Distribution" },
];

export const companyValues = [
  {
    icon: "🏆",
    title: "Quality Excellence",
    description: "Every product is crafted to meet the highest pharmaceutical standards, ensuring safety and efficacy.",
  },
  {
    icon: "🔬",
    title: "Scientific Innovation",
    description: "Backed by research and cutting-edge formulations to deliver superior health outcomes.",
  },
  {
    icon: "🌿",
    title: "Holistic Wellness",
    description: "We embrace both modern medicine and herbal remedies for comprehensive health solutions.",
  },
  {
    icon: "🤝",
    title: "Patient Trust",
    description: "Building lasting relationships with healthcare professionals and patients through transparency.",
  },
];
